import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { ChatPage } from '../chat/chat';
import { UserProvider } from '../../providers/user/user.provider';
import { ChatProvider } from '../../providers/chat/chat.provider';

/**
 * Generated class for the ChatListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-chat-list',
  templateUrl: 'chat-list.html',
})
export class ChatListPage {
  user:any;
  events:any;
  user_list = [];
  users: any = [];

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public userProvider: UserProvider,
    public chatProvider: ChatProvider
  ) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ChatListPage');
    this.refresh();
  }
  async refresh(){
    this.user = await this.userProvider.getUser();
    if(this.user && this.user.uid){
      this.loadEvents();
    }
  }
  async loadEvents(){
    let events = await this.chatProvider.getUserChat(this.user.uid);
    for(let event of events){
      if (this.user_list.indexOf(event.last_message.user_id) == -1) {
        this.user_list.push(event.last_message.user_id);
      }
    }
    await this.loadUsers();
    this.events = events;
    console.log("this.events",this.events )
    console.log("this.users",this.users )
  }
  async loadUsers(){
    for (let user of this.user_list) {
      // console.log("loadUsers user", user);
      if (!this.users[user]) {
        this.users[user] = await this.userProvider.getUser(user);
        // console.log("result",result);
      }
    }
  }
  goToChat(event){
    this.navCtrl.push(ChatPage,{event:event,fromChat:true});
  }
}



// WEBPACK FOOTER //
// ./src/pages/chat-list/chat-list.ts